/** Visual quality and physical capacity are independent dimensions. */
export function stadiumImage(facilitiesRating: number, capacity: number): string {
  const stars = Number.isFinite(facilitiesRating) ? Math.max(1, Math.min(5, Math.round(facilitiesRating * 2) / 2)) : 1;
  const seats = Number.isFinite(capacity) && capacity > 0 ? capacity : 15000;
  const size = seats < 30000 ? 'compact' : seats < 50000 ? 'medium' : seats < 80000 ? 'large' : 'monumental';
  return `assets/images/stadium/stadium-${stars.toFixed(1).replace('.', '-')}-${size}.jpg`;
}
